import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY as C } from "../constants/company";
import { LEGAL_SLUGS } from "../legal";
import { LangSwitch } from "./Header";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-line bg-canvas">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="font-display text-3xl font-extrabold tracking-tight text-ink">
              GOOX<span className="ml-0.5 inline-block h-2 w-2 rounded-full bg-gradient-to-br from-violet-500 to-pink-500" />
            </p>
            <p className="mt-3 text-base text-ink-2">{t.footer.tagline}</p>
            <div className="mt-6 flex items-center gap-3">
              <span data-testid="footer-18plus-notice" className="inline-flex h-10 w-10 items-center justify-center rounded-full border-2 border-ink font-display text-xs font-extrabold">
                18+
              </span>
              <p className="max-w-xs text-xs leading-relaxed text-mist">{t.footer.ageNotice}</p>
            </div>
            <div className="mt-6">
              <LangSwitch compact />
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow text-mist">{t.footer.platform}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-discover" to="/discover" className="text-ink-2 hover:text-violet-700">{t.nav.discover}</Link></li>
              <li><Link to="/#creators" className="text-ink-2 hover:text-violet-700">{t.footer.forCreators}</Link></li>
              <li><Link to="/#fans" className="text-ink-2 hover:text-violet-700">{t.footer.forFans}</Link></li>
              <li><Link to="/#how" className="text-ink-2 hover:text-violet-700">{t.nav.howItWorks}</Link></li>
              <li><Link to="/#waitlist" className="text-ink-2 hover:text-violet-700">{t.nav.waitlist}</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow text-mist">{t.footer.company}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-about" to="/about" className="text-ink-2 hover:text-violet-700">{t.nav.about}</Link></li>
              <li><Link to="/legal/complaints" className="text-ink-2 hover:text-violet-700">{t.footer.contact}</Link></li>
            </ul>
            <div data-testid="footer-cap-group-info" className="mt-5 rounded-2xl border border-line bg-white p-4 text-xs leading-relaxed text-ink-2">
              <p className="font-semibold text-ink">{C.legalName}</p>
              <p>NIT {C.nit}</p>
              <p>{C.address}, {C.city}</p>
              <p>{C.country}</p>
              <p className="mt-1">{C.email}</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow text-mist">{t.footer.legal}</p>
            <ul className="mt-4 grid grid-cols-1 gap-2.5 text-sm">
              {LEGAL_SLUGS.map((s) => (
                <li key={s}>
                  <Link data-testid={`footer-legal-${s}`} to={`/legal/${s}`} className="text-ink-2 hover:text-violet-700">
                    {t.legalTitles[s]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-line pt-6 text-xs text-mist sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {C.year} {C.legalName}. {t.footer.rights}</p>
          <p>
            {t.footer.operatedBy} <span className="font-semibold text-ink-2">{C.legalName}</span> · {C.domain}
          </p>
        </div>
      </div>
    </footer>
  );
};
